import { render, staticRenderFns } from "./AddRTReport.vue?vue&type=template&id=1aabb36a"
import script from "./AddRTReport.vue?vue&type=script&lang=js"
export * from "./AddRTReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports